import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_PAGE_CONTENT_LIST,
    getPageContentListFail,
    getPageContentListSuccess
} from '../action/getPageContentListAction'

// api 
import getPageContentListApi from '../api/getPageContentListApi'

export function* getPageContentListSaga(action) {
    try {
        const response = yield call(() => getPageContentListApi(action.params))
        if (response.data.status === 1) {
            yield put(getPageContentListSuccess(response, action))
        } else {
            yield put(getPageContentListFail(response, action))
        }
    }
    catch (e) {
        yield put(getPageContentListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_PAGE_CONTENT_LIST, getPageContentListSaga)
}